import { graphql, useFragment } from 'react-relay';

import type { Plugin_charge$key } from './__generated__/Plugin_charge.graphql.ts';
import type { Plugin_query$key } from './__generated__/Plugin_query.graphql.ts';
import Order from '../order/Order.tsx';

import type { ReactNode } from 'react';

type Props = {
  query: Plugin_query$key;
  charge: Plugin_charge$key;
  onCloseSuccess: () => void;
};
const Plugin = ({ onCloseSuccess, ...props }: Props): ReactNode => {
  const query = useFragment<Plugin_query$key>(
    graphql`
      fragment Plugin_query on Query {
        ...Order_query
      }
    `,
    props.query,
  );

  const charge = useFragment<Plugin_charge$key>(
    graphql`
      fragment Plugin_charge on Charge {
        ...Order_charge
      }
    `,
    props.charge,
  );

  return (
    <Order
      query={query}
      charge={charge}
      isTemp={false}
      onCloseSuccess={onCloseSuccess}
    />
  );
};

export default Plugin;
